// libraries
import React from 'react'

// components
import Section from '/react4xp/components/Section'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils'

// props
export interface CampaignProps {
	// Content selector - allows hero or article content type
	campaign?: string

	// View mode - with or without image
	view?: 'with-image' | 'without-image'

	// Background color variant
	background?: 'white' | 'light' | 'dark'

	// Optional heading override
	heading?: string

	// Removed: notShowHeading

	// Optional description/ingress override
	description?: string

	// Removed: notShowDescription

	// Optional header image override
	header_image?: string

	// Show date - accepts formatted string
	showdate?: string

	// Show labels/tags (array of content references for tags and themes)
	showlabels?: string[]

	// Author name text
	showauthor?: string

	// Link to campaign
	campaignLink?: string
}

export default function Campaign({
	campaign,
	view = 'with-image',
	background = 'white',
	heading,
	description,
	header_image,
	showdate,
	showlabels,
	showauthor,
	campaignLink
}: CampaignProps) {

	// map background -> Section bgColor utility classes
	const bgColor = background === 'dark' ? 'primary' : background === 'light' ? 'secondary' : 'white'
	return (
		<Section
			bgColor={bgColor}
			className={`campaign campaign--${background} campaign--${view}`}
		>
			<div className='campaign__wrapper'>
				{campaignLink && (
					<a href={campaignLink} className='campaign__link card-link'>
						<span className='sr-only'>Gå til kampanjen: {heading}</span>
					</a>
				)}
				<div className='campaign__author-date-mobile bg-white primary'>
					<div className='container'>
						{showauthor && isNonWhitespaceString(showauthor) && (
							<div className='campaign__author'>
								{showauthor}
							</div>
						)}

						{showdate && isNonWhitespaceString(showdate) && (
							<div className='campaign__date'>
								{showdate}
							</div>
						)}
					</div>
				</div>


				<div className='campaign__container container'>
					<div className='campaign__content'>
						<div className='campaign__content-header'>

							{showauthor && isNonWhitespaceString(showauthor) && (
								<div className='campaign__author'>
									{showauthor}
								</div>
							)}

							{heading && isNonWhitespaceString(heading) && (
								<h2 className='campaign__heading'>
									{heading}
								</h2>
							)}
						</div>

						{(showdate || (showlabels && showlabels.length > 0)) && (
							<div className='campaign__meta'>
								{isNonWhitespaceString(showdate) && (
									<div className='campaign__tag'>
										<span className='campaign__date'>
											{showdate}
										</span>
									</div>
								)}

							{showlabels && showlabels.length > 0 && (
								<>
									{showlabels.map((label, i) => (
										<div key={i} className='campaign__tag'>
											<span className='campaign__label'>
												{label}
											</span>
										</div>
									))}
								</>
							)}
							</div>
						)}

						{description && isNonWhitespaceString(description) && (
							<div className='campaign__description'>
								{description}
							</div>
						)}
					</div>
				</div>


				{/* hero content will be rendered here */}
				{view === 'with-image' && header_image && (
					<div className='campaign__image'>
						<img src={header_image} alt='' />
					</div>
				)}


			</div>
		</Section>
	)
}